import { Tabs } from "antd";
import { isEmpty } from "lodash";
import React from "react";

function OrderedUserComponent({ orderedData }) {
  const listItems =
    !isEmpty(orderedData) &&
    Object.keys(orderedData)?.map((item) => {
      return {
        label: item,
        key: item,
        children: (
          <div className="">
            <div className="d-flex border border-2 rounded bg-secondary  text-white mt-n1">
              <div className="flex-1 border-end p-2">Display Title</div>
              <div className="flex-1 p-2">Slug</div>
            </div>
            {orderedData[item]?.map((order, index) => {
              const dataLength = orderedData[item]?.length - 1;
              return (
                <div
                  className={
                    index == dataLength
                      ? "d-flex border border-2 rounded text-secondary hover-bg-primary"
                      : "d-flex border border-bottom-0 border-2 text-secondary hover-bg-primary"
                  }
                >
                  <div
                    className="flex-1 border-end"
                    style={{ padding: "4.8px" }}
                  >
                    <span className="text-black">{order?.display_title}!</span>{" "}
                  </div>
                  <div className="flex-1 " style={{ padding: "4.8px" }}>
                    <span className="text-black">{order?.slug}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ),
      };
    });

  return (
    <div className="mx-2">
      <Tabs
        defaultActiveKey="1"
        tabPosition="top"
        style={{
          height: 220,
        }}
        items={listItems?.map((item) => {
          return {
            label: item?.label,
            key: item?.key,
            children: item?.children,
          };
        })}
      />
    </div>
  );
}

export default OrderedUserComponent;
